<template>
  <div class="nx-flex-justify-center">
    <slot></slot>
  </div>
</template>
<script>
export default {
  name: 'NxOperateBtn',
  components: {},
  props: {

  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {},
  methods: {},
};
</script>
<style scoped lang="scss">
.van-button{
  width: 168px;
  height: 42px;
  background: #0450B4;
  border-radius: 21px;
  color: #fff;
  font-size: 14px;
}
</style>
